import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	PhoneAndroid,
	KeyboardArrowDown,
	Email,
	Call,
} from '@material-ui/icons'
import { Menu, MenuItem } from '@material-ui/core'
import Button from 'components/theme/Button'
import { selectFromEmail, changeFromName } from 'actions/inbox'
import { Link } from 'react-router-dom'
import { list, read, create } from 'actions/data'

class FromEmailMenu extends Component {
	state = { anchorEl: null }

	componentDidMount() {
		this.props.list('email/valid_sending_addresses', 'address')
		this.props
			.read(null, 'email/verify_my_address_status', null, 'none')
			.then((payload) => {
				console.log('payload:')
				console.log(payload)
				if (payload?.display_name) {
					this.props.changeFromName(payload.display_name)
				}
			})
	}

	handleClick = (event) => {
		this.setState({ anchorEl: event.currentTarget })
	}

	handleClose = () => {
		this.setState({ anchorEl: null })
	}

	render() {
		const { messageType, selectFromEmail, selectedFromEmail } = this.props
		const { anchorEl } = this.state

		const typeObj = {
			text: { icon: <PhoneAndroid style={{ marginRight: 5 }} /> },
			email: { icon: <Email style={{ marginRight: 5 }} /> },
			call: { icon: <Call style={{ marginRight: 5 }} /> },
		}

		return (
			<Fragment>
				{selectedFromEmail.address === 'none' ? (
					/* eslint-disable-next-line */
					<Link to="/accountsettings">Enter a from address</Link>
				) : (
					<Button
						style={{
							margin: '0 0 0 5px',
							textTransform: 'none',
							maxWidth: 200,
							overflow: 'hidden',
							whiteSpace: 'nowrap',
							justifyContent: 'left',
						}}
						variant="outlined"
						size="small"
						aria-owns={anchorEl ? 'simple-menu-from-email' : undefined}
						aria-haspopup="true"
						onClick={this.handleClick}
						title={selectedFromEmail.address}
						// disabled={!conversationSelected && !contactSelected}
					>
						{typeObj[messageType].icon}
						{selectedFromEmail.address}
						<KeyboardArrowDown />
					</Button>
				)}
				<Menu
					id="simple-menu-from-email"
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={() => this.handleClose()}
				>
					{Object.values(
						this.props?.['email/valid_sending_addresses'] || {},
					).map((fromEmail) => (
						<MenuItem
							disabled={fromEmail?.status !== 'success'}
							key={`fromNumberSelectFieldValue${fromEmail?.address}`}
							value={fromEmail}
							onClick={() => {
								this.handleClose()
								selectFromEmail(fromEmail)
							}}
						>
							{fromEmail?.display_name ? `${fromEmail.display_name} ` : ''}
							{`<${fromEmail?.address}>`}
						</MenuItem>
					))}
					{/*typeof fromNumbers === 'object' &&
						Object.values(fromNumbers).map((fromNumber) => (
							<MenuItem
								key={`fromNumberSelectFieldValue${fromNumber.id}`}
								value={fromNumber}
								onClick={() => {
									this.handleClose()
									selectFromEmail(fromNumber)
								}}
							>
								{fromNumber.address}
							</MenuItem>
						))*/}
				</Menu>
			</Fragment>
		)
	}
}

export default connect(
	(state) => ({
		messageType: state.inbox.to.current.type,
		selectedFromEmail: state.inbox.fromEmailSelected,
		'email/valid_sending_addresses':
			state.data?.['email/valid_sending_addresses'],
	}),
	(dispatch) =>
		bindActionCreators(
			{ selectFromEmail, list, create, read, changeFromName },
			dispatch,
		),
)(FromEmailMenu)
